import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export function CTAButton({ to, href, onClick, children, variant = "solid", className = "", testId, type }) {
  const base =
    "sweep-btn inline-flex items-center justify-center gap-2 px-7 py-4 text-sm font-semibold uppercase tracking-[0.14em] transition-transform duration-300 will-change-transform hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[var(--brand)]";
  const styles =
    variant === "solid"
      ? "bg-[var(--brand)] text-white"
      : variant === "dark"
      ? "bg-[var(--ink)] text-white"
      : "border border-[var(--ink)]/20 text-[var(--ink)] bg-white sweep-btn hover:text-white";

  const content = (
    <>
      <span className="relative z-10 flex items-center gap-2">{children}</span>
    </>
  );

  const cls = `${base} ${styles} ${className}`;

  if (to) return <Link to={to} data-testid={testId} className={cls}>{content}</Link>;
  if (href) return <a href={href} data-testid={testId} className={cls}>{content}</a>;
  return <button type={type || "button"} onClick={onClick} data-testid={testId} className={cls}>{content}</button>;
}

export function ArrowLink({ to, children, testId, className = "" }) {
  return (
    <Link
      to={to}
      data-testid={testId}
      className={`group inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.14em] text-[var(--brand)] ${className}`}
    >
      {children}
      <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </Link>
  );
}
